import React, { Fragment, useRef } from 'react';
import emailjs from '@emailjs/browser';

import ActionBtn from './../components/Button/ActionBtn';
import Layout from './../components/Layout/Layout';

import { Col, Container, Row } from 'react-bootstrap';

const Contact = () => {
  // 1. Create a reference for the form
  const formRef = useRef();

  // 2. Create a handler for form submission
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_gfkc2kq',   // Replace with your Service ID
        'template_1jpa7bo', // Replace with your Template ID
        formRef.current,    // Reference to the form
        '8J8V4858Q6wP1K6dB'  // Replace with your Public Key
      )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          // This alert will appear on successful email send
          alert('Your message has been sent successfully to our legal team. We will get back to you shortly.');
          // Optionally clear the form
          e.target.reset();
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Oops! Something went wrong. Please try again later.');
        }
      );
  };

  return (
    <Fragment>
      <Layout
        title='Investment and Trading'
        description='Investment and Trading Desc'
      >
        {/* Hero Section */}
        <section className='pt-[50px] md:pt-[80px] pb-0 relative overflow-hidden'>
          <img
            src={"/images/Container.svg"}
            className='absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none'
            alt=""
          />
          <Container className='relative z-[1] mt-[3rem]'>
            <h2 className='font-bold text__72 mb-10 sm:mb-[3rem] lg:mb-[5rem] text-center text-black'>
              Contact Us
            </h2>
          </Container>
        </section>

        {/* Contact Details Section */}
        <section>
          <Container>
            <Row className='justify-between lg:px-4 xl:px-[2.5rem]'>
              <Col md={6} xl={5}>
                <h3 className='font-medium text__64 mt-5 mb-5 text-black'>
                  Ignite the ⎯ Conversation
                </h3>
                <p className='font-small text__24 text-black leading-relaxed'>
                  Let's start a journey together. Reach out to us today and
                  witness how our solutions can revolutionize your business
                  through strategic technology solutions. Your future starts
                  with a simple click.
                </p>
              </Col>
              <Col md={6} xl={5}>
                <div className="grid grid-rows-1 gap-y-3 text-black">
                  {[
                    {
                      icon: "/images/asa (1).svg",
                      title: "Careers",
                      desc: "careers@futeur.ai",
                    },
                    {
                      icon: "/images/asa (2).svg",
                      title: "Legal Inquiries",
                      desc: "legal@futeur.ai",
                    },
                    {
                      icon: "/images/asa (3).svg",
                      title: "Press & Media",
                      desc: "team@futeurmedia.com",
                    },
                    {
                      icon: "/images/asa (3).svg",
                      title: "Accounts",
                      desc: "accounts@futeur.ai",
                    },
                  ].map((obj, idx) => {
                    return (
                      <div
                        key={idx}
                        className="flex items-start gap-4 py-[2rem] border-b !border-Mneutral200"
                      >
                        <div className="w-[56px] xl:w-[72px] h-[56px] xl:h-[72px] rounded-[10px] bg-Mneutral100 flex items-center justify-center flex-shrink-0">
                          <img src={obj.icon} alt="" />
                        </div>

                        <div>
                          <h5 className='font-medium text__24 mb-2'>
                            {obj.title}
                          </h5>
                          <p className='text__16'>{obj.desc}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Video / Location Section */}
        <section className='py-2'>
          <div className="xs:px-2">
            <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
              <Container>
                <div className="grid grid-rows-1 gap-y-6">
                  <div className="w-full p-3 bg-white rounded-[32px]">
                    <Row className='justify-between gap-y-3'>
                      <Col md={5} className='my-auto'>
                        <video
                          src="/ContactUs.mov"
                          className="rounded-[20px]"
                          autoPlay
                          loop
                          muted
                          playsInline
                          alt=""
                        />
                      </Col>
                      <Col md={7} className='my-auto'>
                        <div className="lg:px-[4rem]">
                          <h4 className='font-medium text__48 mb-2 mt-4 text-black text-center'>
                            New York Office
                          </h4>
                          <p className='text__18 leading-relaxed mt-6 mb-3 text-black font-bold text-center'>
                            Where Opportunity Never Sleeps <br/>
                            Welcome to the Heart of It All
                          </p>

                          <p className='text__18 leading-relaxed mb-[3rem] mt-4 text-black text-center'>
                          <a 
                            href="https://www.google.com/maps/place/1+Rockefeller+Plaza/@40.7580669,-73.9814291,17z/data=!3m2!4b1!5s0x89c258fee742f63b:0xb825fcec3da79dd0!4m6!3m5!1s0x89c258feea4b3f21:0x378ee091a5c43cb!8m2!3d40.7580629!4d-73.9788542!16s%2Fg%2F11gf2dkh1d?entry=tts&g_ep=EgoyMDI0MTIxMS4wIPu8ASoASAFQAw%3D%3D" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="text-Msecondary700 hover:underline"
                          >
                            1 Rockefeller Plaza <br/>Floor 6, <br/>New York, NY 10020
                          </a>
                        </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className='py-2'>
          <div className="px-2">
            <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
              <Container className="relative z-[1] mt-[3rem]">
                <Row className='gap-y-4'>
                  <Col md={6}>
                    <h2 className='font-medium text__64 mb-2 text-black'>
                      Get in ⎯ <br />touch with us
                    </h2>
                    <p className='text__18 leading-relaxed text-Mneutral700 pt-4 pb-4'>
                      We’re here to help! Whether you have a question about our
                      services, need assistance with your account, or want to
                      provide feedback, our team is ready to assist you.
                    </p>

                    <div className="my-3">
                      <p className='text__18 leading-relaxed text-Mneutral700'>
                        Email
                      </p>
                      <a
                        href="mailto:support@futeur.ai"
                        className='font-medium text__24 text-Msecondary700'
                      >
                        support@futeur.ai
                      </a>
                    </div>
                    <div className="mt-3 mb-8">
                      <p className='text__18 leading-relaxed text-Mneutral700'>
                        Phone
                      </p>
                      <div className='font-medium text__24 text-Mneutral900'>
                        + 800-396-7295
                      </div>
                      <p className='text__14 leading-relaxed text-Mneutral600'>
                        Available Monday to Friday, 9 AM - 6 PM GMT
                      </p>
                    </div>
                  </Col>

                  {/* FORM START */}
                  <Col md={6}>
                    <form
                      ref={formRef}
                      onSubmit={sendEmail}
                      className="w-full p-8 rounded-[32px] bg-white"
                    >
                      <Row className='gap-y-3'>
                        <Col md={6}>
                          <label
                            className='font-medium text__12 text-Mneutral700 mb-2'
                            htmlFor="first_name"
                          >
                            First Name
                          </label>
                          <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            placeholder='Enter your first name...'
                            className='w-full h-[46px] px-3 rounded-full bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                            required
                          />
                        </Col>
                        <Col md={6}>
                          <label
                            className='font-medium text__12 text-Mneutral700 mb-2'
                            htmlFor="last_name"
                          >
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            placeholder='Enter your last name...'
                            className='w-full h-[46px] px-3 rounded-full bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                            required
                          />
                        </Col>
                        <Col md={12}>
                          <label
                            className='font-medium text__12 text-Mneutral700 mb-2'
                            htmlFor="email"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder='Enter your email address...'
                            className='w-full h-[46px] px-3 rounded-full bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                            required
                          />
                        </Col>
                        <Col md={12}>
                          <label
                            className='font-medium text__12 text-Mneutral700 mb-2'
                            htmlFor="message"
                          >
                            How can we help you?
                          </label>
                          <textarea
                            id="message"
                            name="message"
                            placeholder='Enter your message...'
                            className='w-full h-[144px] px-3 py-2 rounded-[20px] bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                            required
                          />
                        </Col>
                      </Row>

                      <div className="mt-[2rem] text-right">
                        {/* Submit Button with Alert on Success */}
                        <ActionBtn 
                        title="Send Message"
                        variant={3}     // black background with white text
                        isSubmit={true} // renders <button type="submit">
                      />
                      </div>
                    </form>
                  </Col>
                  {/* FORM END */}
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </Layout>
    </Fragment>
  );
};

export default Contact;

